import React from 'react';
import TileGroup from './TileGroup';
import AcademicForeignObject from './AcademicForeignObject';

interface ComponentConfig {
    component: React.ComponentType<any>;
    props: {
        cx?: number;
        cy?: number;
        r?: number;
        tx?: number;
        ty?: number;
        texture?: string;
    };
    key: string;
}

interface AcademicProps {
    specialTiles: ComponentConfig[];
    facadeTiles: [number, number][];
    groupCoordinates: [number, number][];
}

const Academic: React.FC<AcademicProps> = ({ specialTiles, facadeTiles, groupCoordinates }) => {
    return (
        <TileGroup
            specialTiles={specialTiles}
            facadeTiles={facadeTiles}
            groupCoordinates={groupCoordinates}
            groupName="academic"
            displayText="ACADEMIC"
            backgroundTexture="/textures/dark_oak_planks.png"
            foreignObjectComponent={AcademicForeignObject}
            zoomScale={2.5}
        />
    );
};

export default Academic;